<div class="offcanvas offcanvas-end" tabindex="-1" #rightPanel aria-labelledby="offcanvasLabel"
  data-bs-scroll="true" data-bs-backdrop="false" [style.z-index]="zIndex"
  [style.width]="isMobile ? '100vw' : '400px'"
  [style.min-width]="isMobile ? '100vw' : '400px'"
  [style.max-width]="isMobile ? '100vw' : '400px'"
  [ngClass]="{'off-screen': !isOpen, 'responsive-panel': isResponsive}">
  <div class="offcanvas-header border-bottom">
    <h1 class="offcanvas-title" id="offcanvasLabel">{{title}}</h1>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" (click)="closePanel()">
    </button>
  </div>

  @if (bodyComponent && shouldShowComponent) {
    <div class="offcanvas-body p-0">
      <ng-container #rightComponent *ngComponentOutlet="bodyComponent"></ng-container>
    </div>
  }
</div>